import { PermissionService } from '@abp/ng.core';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GoliathAppPermission } from '@digiwall/goliath-core/config';
import { AccessibleRoutesService } from './accessible-routes.service';

/**
 * The home dashboard belongs to full ERP users. Anybody else is sent straight to the first screen
 * they are allowed to open, so a restricted role never faces an empty landing page.
 *
 * `AccessibleRoutesService` excludes `/home`, so this can never redirect to itself.
 */
export const homeLandingGuard: CanActivateFn = () => {
  if (inject(PermissionService).getGrantedPolicy(GoliathAppPermission.Access)) {
    return true;
  }

  const landingPath = inject(AccessibleRoutesService).findLandingPath();

  return landingPath ? inject(Router).parseUrl(landingPath) : true;
};
